import React from 'react';
import { observer } from 'src/utils/mobx-react';
import { GlobalPage } from 'src/components/GlogalPage/GlobalPage';
import { LandingPage } from 'src/components/LandingPage/LandingPage';
import { NotificationPage } from 'src/components/NotificationPage/NotificationPage';
import { HeaderLinkPanel } from 'src/components/NavigationLinkPanel/NavigationLinkPanel';
import { HeroWidget } from 'src/components/HeroWidget/HeroWidget';
import { Sports } from 'src/main/cms/Sports/Sports';
import { SpecialSports } from 'src/main/cms/SpecialSports/SpecialSports';
import { LiveNotificationsPage } from 'src/components/LiveNotificationsPage/LiveNotificationsPage';
import { useAppStateContext } from 'src/AppState/AppState';
import { PromoCodes } from 'src/components/PromoCodes/PromoCodes';
import { WelcomeBonus } from 'src/components/WelcomeBonus/WelcomeBonus';
import { CarouselPromoComponent } from 'src/main/cms/HomePageCarousel/CarouselPromoComponent';
import { TranslationsContent } from 'src/components/TranslationsContent/TranslationsContent';
import { HeadlineCarousel } from 'src/main/cms/HeadlineCarousel/HeadlineCarousel';
import { FooterManagement } from 'src/main/cms/FooterManagement/FooterManagement';
import { PromotedEvents } from 'src/main/cms/PromotedEvents/PromotedEvents';
import { CasinoBanners } from 'src/main/cms/CasinoBanners/CasinoBanners';
import { SeoPagesComponent } from 'src/main/cms/SeoManagement/SeoPages';
import { GlobalPageV2 } from 'src/components/GlobalPageV2/GlobalPageV2';
import { PagesV2 } from 'src/components/Pages/PagesV2';
import { QuickLinkTray } from 'src/main/cms/QuickLinkTray/QuickLinkTray';
import { Pages } from 'src/components/Pages/Pages';
import { ConfigState } from 'src/AppState/ConfigState/ConfigState';
import { useCommon } from 'src/AppState/Common';
import { TopEvents } from 'src/main/cms/TopEvents/TopEvents';

export const CmsPageContent = observer('CmsPageContent', (): React.ReactElement => {
    const { routerBackoffice } = useAppStateContext();
    const common = useCommon();
    const configComponents = ConfigState.get(common);
    const cmsParams = routerBackoffice.getParametersString('global', 'tab') ?? 'global';
    const isPromoCodeVisible = !configComponents.config.cmsHiddenTabs.includes('promoCode');
    const isWelcomeBonusVisible = !configComponents.config.cmsHiddenTabs.includes('welcomeBonus');

    return (
        <>
            {cmsParams === 'casinoBanners' && <CasinoBanners />}
            {/* {cmsParams === 'eventDetails' && <EventDetails />} */}
            {cmsParams === 'footerManagement' && <FooterManagement />}
            {cmsParams === 'global' && <GlobalPage />}
            {/* TEMPORARY PARAM FOR CREATING NEW CMS PAGE */}
            {cmsParams === 'globalV2' && <GlobalPageV2 />}
            {cmsParams === 'headerLinkPanel' && <HeaderLinkPanel />}
            {cmsParams === 'headlineCarousel' && <HeadlineCarousel />}
            {cmsParams === 'heroWidget' && <HeroWidget />}
            {cmsParams === 'homePageCarousel' && <CarouselPromoComponent />}
            {cmsParams === 'landingPage' && <LandingPage />}
            {cmsParams === 'liveNotificationsPage' && <LiveNotificationsPage />}
            {cmsParams === 'notificationPage' && <NotificationPage />}
            {cmsParams === 'pages' && <Pages />}
            {/* TEMPORARY PARAM FOR CREATING NEW CMS PAGE */}
            {cmsParams === 'pagesV2' && <PagesV2 />}
            {cmsParams === 'promoCode' && isPromoCodeVisible && <PromoCodes />}
            {cmsParams === 'quickLinkTray' && <QuickLinkTray />}
            {cmsParams === 'specialSports' && <SpecialSports />}
            {cmsParams === 'sports' && <Sports />}
            {cmsParams === 'promotedEvents' && <PromotedEvents />}
            {cmsParams === 'topEvents' && <TopEvents />}
            {cmsParams === 'translations' && <TranslationsContent />}
            {cmsParams === 'welcomeBonus' && isWelcomeBonusVisible && <WelcomeBonus />}
            {cmsParams === 'seoManagement' && <SeoPagesComponent />}
        </>
    );
});
